import { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Button } from 'components/UI/Button/Button';
import { DropdownWithMenu } from 'components/UI/DropdownWithMenu/DropdownWithMenu';
import { appConstants } from 'utils/global-constants';
import { EventFiltersModal } from './EventFiltersModal/EventFiltersModal';
import { ActiveFilters } from './ActiveFilters';
import { EventFiltersContext } from '../../Shared/EventFiltersProvider';

export const EventFilters = (props) => {
  const { FilterSet, GenreId, SortByActive, FiltersActive } = props;
  const { sortOrder, setSortOrder, setSelectedGenreId, appliedFilters, setAppliedFilters } =
    useContext(EventFiltersContext);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [eventFilters, setEventFilters] = useState([]);

  const genreOrderBy = appConstants.GenreOrderBy;
  const openFilterModalHandler = () => {
    setModalIsOpen(true);
  };
  const closeFilterModalHandler = () => {
    setModalIsOpen(false);
  };

  const sortByChangeHandler = (selectedSortBy) => {
    const sortByValue = Number(selectedSortBy);

    // avoid api call when there's no change in sortOrder
    if (sortByValue !== sortOrder) {
      setSortOrder(sortByValue);
    }
  };

  useEffect(() => {
    setSelectedGenreId(GenreId);
    if (window.location.search) {
      const search = Array.from(new URLSearchParams(window.location.search));
      const filters = [];

      search.forEach(([urlPart, itemURLDescriptionsString]) => {
        const itemURLDescriptions = itemURLDescriptionsString.split(',');
        const filterSet = FilterSet.find((filter) => decodeURIComponent(filter.URLPart) === urlPart);
        const filterItems = filterSet?.Items.filter((item) => itemURLDescriptions.includes(item.UrlDescription));
        if (filterItems && filterItems.length) {
          filters.push({
            FilterId: filterSet.Id,
            SelectedOptions: filterItems.map((item) => item.Id),
          });
        }
      });

      setAppliedFilters(filters);
      setEventFilters(filters);
    }
  }, []);

  return (
    <>
      <div className="event-filters event-filters-container">
        <div className="bg-light-putty">
          <div className="container filter-controls">
            <div className="row">
              {FilterSet.length > 0 && (
                <div className="col-sm-4">
                  <Button
                    extendClass="event-filters__filter-button"
                    extendTestId="search-filter"
                    endIcon={<ArrowDropDownIcon />}
                    onClick={openFilterModalHandler}
                  >
                    Filter results
                  </Button>
                </div>
              )}

              {SortByActive && (
                <div className="col-xs-12 col-sm-3 col-md-2 pull-right">
                  <div className="form-group dropdown-sortby">
                    <div className="input-container">
                      <DropdownWithMenu
                        defaultValue="Sort by"
                        defaultChosenValue="Date"
                        menuData={genreOrderBy}
                        dropdownChangeHandler={sortByChangeHandler}
                        extendClass="event-filters__sort-by"
                        singleColumn
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {FiltersActive && appliedFilters?.length > 0 && (
          <ActiveFilters filterSet={FilterSet} setEventFilters={setEventFilters} />
        )}
      </div>
      <EventFiltersModal
        modalIsOpen={modalIsOpen}
        filterSet={FilterSet}
        closeModalHandler={closeFilterModalHandler}
        eventFilters={eventFilters}
        setEventFilters={setEventFilters}
      />
    </>
  );
};

EventFilters.propTypes = {
  FilterSet: PropTypes.array,
  GenreId: PropTypes.string,
  SortByActive: PropTypes.bool,
  FiltersActive: PropTypes.bool,
};
